export const SET_LAST_NOTI_TIMESTAMP = 'SET_LAST_NOTI_TIMESTAMP'